export const zh_cn = {
	/** 站点 名称 */
	site_name: 'KJcs2',

	/** 站点 域名 */
	site_domain: 'jhskins.com',

	/** 站点 代理域名 */
	site_agent_domain: 'aff.jhskins.com',

	/** 站点 代理QQ */
	site_agent_qq: '3280881367',

	/** 站点 代理邮箱 */
	site_agent_email: '3280881367@qq.com',


	nav_replacement_text: '幸运饰品',
	nav_replacement_secondary_text: 'Replacement',

	replacement: '汰换',
	replacement_success: '成功',
	replacement_failed: '失败',

	forge: '冶炼',
};
